export interface PromptDiffProps {
  a: string;
  b: string;
}

interface DiffRow {
  kind: "same" | "del" | "add" | "chg";
  left: string;
  right: string;
}

function buildRows(a: string, b: string): DiffRow[] {
  const linesA = a.split("\n");
  const linesB = b.split("\n");
  const max = Math.max(linesA.length, linesB.length);
  const rows: DiffRow[] = [];
  for (let i = 0; i < max; i += 1) {
    const la = linesA[i] ?? "";
    const lb = linesB[i] ?? "";
    if (la === lb) rows.push({ kind: "same", left: la, right: lb });
    else if (la === "") rows.push({ kind: "add", left: "", right: lb });
    else if (lb === "") rows.push({ kind: "del", left: la, right: "" });
    else rows.push({ kind: "chg", left: la, right: lb });
  }
  return rows;
}

/** Line-level naïve diff: equal lines unstyled, additions green, deletions red. */
export function PromptDiff({ a, b }: PromptDiffProps) {
  const rows = buildRows(a, b);
  return (
    <pre className="mt-2 grid grid-cols-2 gap-x-2 overflow-x-auto rounded bg-muted p-2 text-xs">
      <div>
        {rows.map((r, i) => (
          <div
            key={`l-${i}`}
            className={
              r.kind === "del" || r.kind === "chg" ? "bg-red-100" : undefined
            }
          >
            {r.left}
          </div>
        ))}
      </div>
      <div>
        {rows.map((r, i) => (
          <div
            key={`r-${i}`}
            className={
              r.kind === "add" || r.kind === "chg" ? "bg-green-100" : undefined
            }
          >
            {r.right}
          </div>
        ))}
      </div>
    </pre>
  );
}
